import React, { Component } from "react";
import { FlagsProvider } from 'flag';

import SimilarTitlesContainer from "../containers/SimilarTitlesContainer";
import SimilarAuthorsContainer from "../containers/SimilarAuthorsContainer";
import SimilarSeriesContainer from "../containers/SimilarSeriesContainer";
import BooksInSeriesContainer from "../containers/BooksInSeriesContainer";
import ReaderReviewsContainer from "../containers/ReaderReviewsContainer";
import ReadingLevelFeatureContainer from "../containers/ReadingLevelFeatureContainer";
import LibraryNewslettersContainer from "../containers/LibraryNewslettersContainer";
import LibraryPostsContainer from "../containers/LibraryPostsContainer";
import EResourcesContainer from "../containers/EResourcesContainer";
import TabGroup from "../containers/TabGroup";
import TabContent from "../containers/TabContent";
import { TabWithCardsContent } from "../containers/TabWithCardsContent";
import AwardWinnersContainer from "react/containers/AwardWinnersContainer";
import BookListsContainer from "react/containers/BookListsContainer";
import ArticlesFromNovelistContainer from "react/containers/ArticlesFromNovelistContainer";
import AttributionContainer from "react/containers/AttributionContainer";
import BookSummaryContainer from "react/containers/bookSummary/BookSummaryContainer";
import InsideThisBookContainer from "react/containers/InsideThisBookContainer"
import AuthorBioContainer from "react/containers/authorBiography/AuthorBioContainer"
import StoryMixerFeatureContainer from "../containers/StoryMixerFeatureContainer";
import ProfessionalReviewsContainer from '../containers/ProfessionalReviewsContainer';
import AcceleratedReaderFeatureContainer from '../containers/acceleratedReader/AcceleratedReaderFeatureContainer';
import MoreAboutThisTitleContainer from '../containers/MoreAboutThisTitleContainer';
import LinkToBookChatContainer from "../containers/LinkToBookChatContainer";
import { logExperimentExposure } from "data/FeatureExperimentation";

import "./card.less";

class CardSetV3 extends Component {
	constructor(){
		super();
		this.numberOfLines = 10;
	}
	setCssParameters() {
		document.documentElement.style.setProperty('--novelist-card-border', '0');
		document.documentElement.style.setProperty('--novelist-card-border-radius', '0');
		document.documentElement.style.setProperty('--novelist-font-family-normal', 'Arial, "Helvetica Neue", Helvetica, sans-serif');
		document.documentElement.style.setProperty('--novelist-font-family-bold', 'Arial, "Helvetica Neue", Helvetica, sans-serif');
		document.documentElement.style.setProperty('--novelist-card-title-font-size', '18px');
		document.documentElement.style.setProperty('--novelist-card-title-font-weight', 'normal');
		document.documentElement.style.setProperty('--novelist-card-title-padding', '5px');
		document.documentElement.style.setProperty('--novelist-card-title-color', 'rgb(235, 235, 235)');
		document.documentElement.style.setProperty('--novelist-link-color', '#0000ee');
		document.documentElement.style.setProperty('--novelist-card-footer-color', 'rgb(235, 235, 235)');
		document.documentElement.style.setProperty('--novelist-book-text-height', '140px');
	}

	onRenderAboutThisBook() {
		logExperimentExposure('aboutthisbook-belowrelatedcontent');
	}

	renderATBAtCurrent() {
		if (!this.props.featureFlags.experimentAboutThisBookToBelowRelatedContent()) {
			return (
				<TabGroup>
					<TabContent name="Story elements">
						<StoryMixerFeatureContainer />
					</TabContent>
					<TabWithCardsContent name="About this book" onRenderWithContent={this.onRenderAboutThisBook}>
						<BookSummaryContainer numberOfLines={this.numberOfLines} />
						<AuthorBioContainer numberOfLines={this.numberOfLines} />
						<InsideThisBookContainer />
					</TabWithCardsContent>
				</TabGroup>
			);
		}
		else {
			return (<TabGroup>
				<TabContent name="Story elements">
					<StoryMixerFeatureContainer />
				</TabContent>
			</TabGroup>);
		}
	}

	renderATBAtBottom() {
		if (this.props.featureFlags.experimentAboutThisBookToBelowRelatedContent()) {
			return (
				<TabGroup>
					<TabWithCardsContent name="About this book" onRenderWithContent={this.onRenderAboutThisBook}>
						<BookSummaryContainer numberOfLines={this.numberOfLines} />
						<AuthorBioContainer numberOfLines={this.numberOfLines} />
						<InsideThisBookContainer />
					</TabWithCardsContent>
				</TabGroup>
			);
		}
	}

	render() {
		this.setCssParameters();

		return (<FlagsProvider flags={this.props.featureFlags}>
			<div>
				<LinkToBookChatContainer />
				<TabGroup>
					<TabContent name="Books in this series">
						<BooksInSeriesContainer />
					</TabContent>
				</TabGroup>
				<TabGroup>
					<TabWithCardsContent name="Read-alikes">
						<SimilarTitlesContainer />
						<SimilarAuthorsContainer />
						<SimilarSeriesContainer />
					</TabWithCardsContent>
				</TabGroup>
				<MoreAboutThisTitleContainer />
				{this.renderATBAtCurrent()}
				<TabGroup>
					<TabWithCardsContent name="Ratings & reviews">
						<ReaderReviewsContainer uiVersionFlag={this.props.featureFlags.novelistSelectUiVersion()}/>
						<ProfessionalReviewsContainer />
						<ReadingLevelFeatureContainer />
						<AcceleratedReaderFeatureContainer />
					</TabWithCardsContent>
				</TabGroup>
				<TabGroup>
					<TabWithCardsContent name="Related content">
						<AwardWinnersContainer />
						<BookListsContainer />
						<ArticlesFromNovelistContainer />
						<LibraryNewslettersContainer />
						<LibraryPostsContainer />
						<EResourcesContainer />
					</TabWithCardsContent>
				</TabGroup>
				{this.renderATBAtBottom()}
				<AttributionContainer />
			</div>
		</FlagsProvider>);
	}
}

export default CardSetV3;



// WEBPACK FOOTER //
// ./src/react/card/CardSetV3.jsx